<template>
  <div class="archived-zadi-sessions">
    <ag-table :data-source-api="getAllArchivedSessions" :grid-options="gridOptions" :permissions="permissions"
      :rtl="false" :is-entities-response="false" @emitExportToExcel="onExportToExcel" />
  </div>
</template>

<script>
import { RepositoryFactory } from "../../volunteer-repositories/volunteerRepositoryFactory";
import AgTable from "@/app/shared/shared-components/ag-grid/AgTableServerSide";
import AgTableBtnCell from "@/app/shared/shared-components/ag-grid/AgTableBtnCell";
import AgButton from "@/app/shared/shared-components/ag-grid/AgButton";
import utilities from "@/app/shared/utilities/index";
import { sessionSupervisorNames } from "../../models";

const zadiSessionsRepo = RepositoryFactory.get("zadiSessionsRepository");

export default {
  name: "ArchivedZadiSessions",
  components: {
    AgTable,
    // eslint-disable-next-line vue/no-unused-components
    AgButton,
    // eslint-disable-next-line vue/no-unused-components
    AgTableBtnCell,
  },
  data() {
    return {
      gridApi: null,
      gridOptions: null,
      apiQuery: "",
      status: {
        completed: "مكتملة",
        cancelled: "ملغية",
      },
      permissions: {
        edit: "training_courses_management",
      },
    };
  },
  methods: {
    createColDefs() {
      let self = this;
      return [
        {
          headerName: "المعرف",
          field: "id",
          sortable: true,
          width: 200,
        },
        {
          headerName: "العنوان",
          field: "title",
          filter: "agTextColumnFilter",
          width: 210,
          sortable: false,
        },
        {
          headerName: "التاريخ",
          field: "date",
          filter: "agDateColumnFilter",
          width: 200,
          sortable: true,
          valueGetter: function getObject(params) {
            return params.data.date ? utilities.formatDate(params.data.date, "yyyy-MM-DD") : "-";
          },
        },
        {
          headerName: "من الساعة",
          field: "startTime",
          width: 160,
          sortable: false,
          valueGetter: function getObject(params) {
            return params.data.startTime ? String(params.data.startTime).substring(0, 5) : "-";
          },
        },
        {
          headerName: "إلى الساعة",
          field: "endTime",
          width: 160,
          sortable: false,
          valueGetter: function getObject(params) {
            return params.data.endTime ? String(params.data.endTime).substring(0, 5) : "-";
          },
        },
        {
          headerName: "المشرفون",
          field: "supervisors",
          width: 240,
          sortable: false,
          valueGetter: function getObject(params) {
            return sessionSupervisorNames(params.data);
          },
        },
        {
          headerName: "عدد المقاعد",
          field: "totalSeats",
          width: 180,
          sortable: true,
        },
        {
          headerName: "عدد المسجلين",
          field: "registeredVolunteersCount",
          width: 180,
          sortable: false,
          valueGetter: function getObject(params) {
            return params.data.registeredVolunteersCount == null
              ? "-"
              : params.data.registeredVolunteersCount;
          },
        },
        {
          headerName: "الحالة",
          field: "status",
          width: 180,
          sortable: false,
          valueGetter: function getObject(params) {
            return self.status[params.data.status] || "-";
          },
          filter: "agSetColumnFilter",
          filterParams: {
            values: Object.keys(self.status),
            valueFormatter: (params) => self.status[params.value] || params.value,
          },
        },
        {
          headerName: "كوبون الحضور",
          field: "attendCouponName",
          width: 200,
          sortable: false,
          valueGetter: function getObject(params) {
            return params.data.attendCouponName || "-";
          },
        },
        {
          headerName: "كوبون التغيب",
          field: "noShowCouponName",
          width: 200,
          sortable: false,
          valueGetter: function getObject(params) {
            return params.data.noShowCouponName || "-";
          },
        },
        {
          headerName: "كوبون الحضور دون تسجيل",
          field: "unregisteredAttendCouponName",
          width: 230,
          sortable: false,
          valueGetter: function getObject(params) {
            return params.data.unregisteredAttendCouponName || "-";
          },
        },
        {
          headerName: "سجل الحضور",
          width: 190,
          sortable: false,
          cellRendererFramework: AgButton,
          valueGetter: function getObject(params) {
            return params.data;
          },
          cellRendererParams: () => {
            return {
              size: "small",
              color: "primary",
              name: "سجل الحضور",
              type: "gradient",
              permission: self.permissions.edit,
              click(session) {
                self.$router.push({
                  path: `/volunteers/zadi-sessions/${session.id}/check-ins`,
                });
              },
            };
          },
        },
        {
          headerName: "الإجراءات",
          sortable: false,
          cellRendererFramework: AgTableBtnCell,
          valueGetter: function getObject(params) {
            return params.data;
          },
          cellRendererParams: {
            repeatRecord: function (session) {
              self.onDuplicateSession(session);
            },
            viewUsersRecord: function (session) {
              self.$router.push({
                path: `/volunteers/zadi-sessions/${session.id}/volunteers`,
              });
            },
            actions: ["repeat", "view-users"],
            permissions: self.permissions,
          },
        },
      ];
    },
    async getAllArchivedSessions(query) {
      this.apiQuery = `${query}&filter=status||$in||completed`;
      return await zadiSessionsRepo.fetchZadiSessions(this.apiQuery);
    },
    async onExportToExcel() {
      await zadiSessionsRepo.exportZadiSessions(this.apiQuery);
    },
    async onDuplicateSession(session) {
      await zadiSessionsRepo.duplicateZadiSession(session.id);
      await this.$router.push({ path: "/volunteers/zadi-sessions" });
    },
  },
  created() {
    this.gridOptions = {};
    this.gridOptions.columnDefs = this.createColDefs();
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
  },
};
</script>
